import Immutable from "immutable"

const SET_IS_ENGAGE_CUSTOMER = "SET_IS_ENGAGE_CUSTOMER"

type SetIsEngageCustomerAction = {
  type: typeof SET_IS_ENGAGE_CUSTOMER
  isEngageCustomer: boolean
}

type MimecastCgAction = SetIsEngageCustomerAction

export function setIsEngageCustomer(
  isEngageCustomer: boolean,
): SetIsEngageCustomerAction {
  return {
    type: SET_IS_ENGAGE_CUSTOMER,
    isEngageCustomer,
  }
}

type MimecastCgState = {
  isEngageCustomer: boolean
}

const defaultState: MimecastCgState = {
  isEngageCustomer: false,
}

export function selectIsEngageCustomer(
  state: Immutable.Map<"mimecastCg", MimecastCgState>,
) {
  return state.getIn(["mimecastCg", "isEngageCustomer"])
}

function mimecastCgReducer(state = defaultState, action: MimecastCgAction) {
  switch (action.type) {
    case SET_IS_ENGAGE_CUSTOMER:
      return {
        ...state,
        isEngageCustomer: action.isEngageCustomer,
      }
    default:
      return state
  }
}

export default mimecastCgReducer
